import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { InterpreterView } from "./InterpreterView";
import { InterpreterViewStore } from "../../store/InterpreterViewStore";
import { useStore } from "../../../../hooks";

export const InterpreterViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/interpreter/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new InterpreterViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "systemDates",
              label: rootStore.langStore.groupInterpreterSystemDatesLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <InterpreterView interpreterViewStore={store} />
      </PageLayout>
    </div>
  );
});
